import { GoogleMap } from "@react-google-maps/api";
import React from "react";

export const GoogleMapComponent = React.memo(({ children, ...props }) => {
    return (
        <GoogleMap {...props}>
            {children}
        </GoogleMap>
    );
});
